import axios from 'axios'

const GET_REFRESH_TOKENS = 'GET_REFRESH_TOKENS'
const GENERATE_REFRESH_TOKEN = 'GENERATE_REFRESH_TOKEN'
const REVOKE_REFRESH_TOKEN = 'REVOKE_REFRESH_TOKEN'
const RESET = 'RESET'

const BASE_URL = 'api/ServiceRegistry/ServiceCredentials'
const GENERATE_REFRESH_TOKEN_URL =
  `${BASE_URL}`
const GENERATE_ACCESS_TOKEN_URL =
  `${BASE_URL}/generateAccessToken/`
const GET_REFRESH_TOKENS_URL =
  `${BASE_URL}`
const RESET_CLIENT_ID_URL =
  `${BASE_URL}/resetClientId`
const REVOKE_REFRESH_TOKEN_URL =
  `${BASE_URL}`
let initialState = () => ({
  serviceCredentials: [],
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    getRefreshTokens({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(GET_REFRESH_TOKENS_URL)
          .then(function(response) {
            commit(GET_REFRESH_TOKENS, response.data)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    generateRefreshToken({ commit }) {
      return new Promise((resolve, reject) => {
        axios.post(GENERATE_REFRESH_TOKEN_URL, null)
          .then(function(response) {
            commit(GENERATE_REFRESH_TOKEN, response.data)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    revokeRefreshToken({ commit }, serviceCredential) {
      return new Promise((resolve, reject) => {
        axios.delete(REVOKE_REFRESH_TOKEN_URL, { data: serviceCredential })
          .then(function(response) {
            commit(REVOKE_REFRESH_TOKEN, serviceCredential)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    generateAccessToken({ commit }) {
      return new Promise((resolve, reject) => {
        axios.post(GENERATE_ACCESS_TOKEN_URL)
          .then(function(response) {
            commit()
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    resetClientId() {
      return new Promise((resolve, reject) => {
        axios.put(RESET_CLIENT_ID_URL)
          .then(function() {
            resolve()
          })
          .catch(function(error) {
            reject(error)
          })
      })
    },
  },
  mutations: {
    [GET_REFRESH_TOKENS](state, serviceCredentials) {
      if (serviceCredentials == null) {
        state.serviceCredentials = []
      } else {
        state.serviceCredentials = serviceCredentials
      }
    },
    [GENERATE_REFRESH_TOKEN](state, serviceCredential) {
      state.serviceCredentials.unshift(serviceCredential)
    },
    [REVOKE_REFRESH_TOKEN](state, serviceCredential) {
      let index = state.serviceCredentials.findIndex(c => c.RefreshTokenId == serviceCredential.RefreshTokenId)
      state.serviceCredentials.splice(index, 1)
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    serviceCredentials: (state) => state.serviceCredentials,
  },
}